export default __webpack_public_path__ + "static/media/old_ehr_migration_sample_image.cc610075.png";